import { Component } from 'preact';
import classNames from 'classnames';
import PropTypes from 'prop-types';

class ButtonFilter extends Component {
  render() {
    const { onClick, isOpen, title, icon } = this.props;

    return (
      <button
        className={classNames(
          'btn button button--large button--no-upper search--button search--button-filter',
          {
            'search--button--active': isOpen,
          },
        )}
        type="button"
        onClick={e => onClick(e)}
      >
        <span>
          <span>
            {isOpen ? 'Fechar' : title}
            <i className={`icon ${icon}`} />
          </span>
        </span>
      </button>
    );
  }
}

ButtonFilter.defaultProps = {
  onClick: () => {},
  isOpen: false,
  title: 'Filtrar',
  icon: 'icon-chevron',
};

ButtonFilter.propTypes = {
  onClick() {},
  isOpen: PropTypes.bool,
  title: PropTypes.string,
  icon: PropTypes.string,
};

export default ButtonFilter;
